import { Injectable } from '@angular/core';

@Injectable()
export class QRPrintService {
  private printStyles = `.text-center { text-align: center;}
    .row {
        display: flex;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
    }
    .text-center {text-align: center!important;}
    .col-12 {
        flex: 0 0 100%;
        max-width: 100%;
    }
    .qr-class{
        width: 400px;
        height: 400px;
    }`;

  /**@deprecated para imprimir directamente se usa window.print()
   * Se configura lo que se va a imprimir con @media print en css*/
  public printQr(printHTML: string, text: string = 'Yacaré QR') {
    // let printContents;
    let popupWin;
    // printContents = document.getElementById('qr-print').innerHTML;
    popupWin = window.open('', 'printWindow', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.write(`
            <html>
                <head><title>${text}</title></head>
                <style>
                ${this.printStyles}
                </style>
                <body onload="window.print();window.close()">
                    ${printHTML}
                    <div class="row">
                        <div class="col-12 text-center">${text}</div>
                    </div>
                </body>
            </html>`);
    popupWin.document.close();
  }
}
